import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

export function useKpiApi() {
    const callApi = useApiCall()

    const getKpiImpacts = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.KPI.KPI_IMPACTS, data, onSuccess, onError)
    }

    const getAvgMetric = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.KPI.AVG_METRIC, data, onSuccess, onError)
    }

    const getAvgNetVolumnPerPocPerDay = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.KPI.AVG_NET_REVENUE_PER_POC_PER_DAY, data, onSuccess, onError)
    }

    const avgKpiPerIntervention = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.KPI.AVG_KPI_PER_INTERVENTION, data, onSuccess, onError)
    }

    const interventionCombination = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.KPI.INTERVENTION_COMBINATION, data, onSuccess, onError)
    }

    return {
        getKpiImpacts,
        getAvgMetric,
        getAvgNetVolumnPerPocPerDay,
        avgKpiPerIntervention,
        interventionCombination,
    }
}
